import React, { Component } from "react";
import { Form, Row, Col, Button, Alert, Modal } from "react-bootstrap";

import { LinkContainer } from "react-router-bootstrap";

import "containers/common/List.css";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import Moment from "moment";
import DatePicker from "react-datepicker";
import Select from 'react-select';

export default class LeaseReviewList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "leaseReviews",
            dataRecord: "leaseReviews",
            dataSetPrimaryKey: "lease_review_id",
            showAlert: false,
            showWarning: false,
            errorMessage: "",
            savingNewRecord: false
        };

        
        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
       
        if (!this.props.isAuthenticated) { // if false
            return;
        }        
        this.setState({ isLoading: false });      
    }



    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }





    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        if (event.detail !== 0) {
            let data = [...this.props.data];
            var r = window.confirm("Are you sure you want to delete this record?");
            if (r === true) {
                console.log(cellInfo);

                data[cellInfo.index].archived_date = new Date();
                await this.handleDataSave(data[cellInfo.index]).then((result) => {
                    data.splice(cellInfo.index, 1);
                    this.props.updateTableState(data, this.state.dataSet);
                }
                )
            };
        }
    };


    handleInputChange = (cellInfo, event) => {
        
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCurrencyChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9.$]/g, "");
        data[cellInfo.index][cellInfo.column.id] = val;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    }
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = Number(val);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handlePercentChange = (cellInfo, event)  => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9.]/g, "").replace(/(?<=[.][0-9]{2})[0-9]*/g,"");
        if (val>100){
            val=100;
        }
        data[cellInfo.index][cellInfo.column.id] = val;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);        
    }
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(event);
        data[cellInfo.index][cellInfo.column.id] = dt.toLocaleDateString('en-AU',options);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleDropDownChange = (cellInfo, event) => {

        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleSave = async (cellInfo, event) => {
        const currencyFormatter = new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 2,
            currencyDisplay: "symbol"
        });
        this.setState({ showAlert: false, showWarning: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        if(data[i].revised_price_per_sqm){
                            data[i].revised_price_per_sqm = currencyFormatter.format(data[i].revised_price_per_sqm.replace(/[^0-9.]/g, ""));
                        }
                        if(data[i].revised_price_per_annum){
                            data[i].revised_price_per_annum = currencyFormatter.format(data[i].revised_price_per_annum.replace(/[^0-9.]/g, ""));
                        }
                        //console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                if(data[i].new_record){
                                    this.setState({ showWarning: true });
                                }
                                else{
                                    this.setState({ showAlert: true });
                                }
                                return;
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                if(data[i].new_record){
                    this.setState({ showWarning: true });
                }
                else{
                    this.setState({ showAlert: true });
                }
            }
        }   
        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        this.props.updateTableState(data, this.state.dataSet);


    }



    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        if (cellInfo.column.id === "review_type_code") {
            if (cellValue) {
                return (<div><Select
                    value={{ value: cellValue, label: this.props.reviewTypeOptions.find(o => o.value === cellValue).label }}
                    onChange={this.handleDropDownChange.bind(null, cellInfo)}
                    options={this.props.reviewTypeOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                /></div>
                );
            }
            else {
                return (<div><Select

                    onChange={this.handleDropDownChange.bind(null, cellInfo)}
                    options={this.props.reviewTypeOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                /></div>
                );
            }
        }

        if (cellInfo.column.id === "lease_term") {
            if (cellValue) {
                return (<div><Select
                    value={{ value: cellValue, label: this.props.leaseTermOptions.find(o => o.value === cellValue).label  }}
                    onChange={this.handleDropDownChange.bind(null, cellInfo)}
                    options={this.props.leaseTermOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                /></div>
                );
            }
            else {
                return (<div><Select

                    onChange={this.handleDropDownChange.bind(null, cellInfo)}
                    options={this.props.leaseTermOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                /></div>
                );
            }
        }

        if (["revised_price_per_sqm", "revised_price_per_annum"].indexOf(cellInfo.column.id) >= 0) {
            if (cellValue) {
                return (<input
                    onChange={this.handleCurrencyChange.bind(null, cellInfo)}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    type="text"
                    className="no-border form-control"
                    value={cellValue!=null?cellValue: " "}
                    
                />
                );
            }
        }

        if (cellInfo.column.id === "percentage") {
            
            return (<input
                        onChange={this.handlePercentChange.bind(null, cellInfo)}
                        onBlur={this.handleSave.bind(null, cellInfo)}
                        type="text"
                        className="no-border form-control"
                        value={cellValue!=null? cellValue+"%": " "}

                    />
            );
           
        }

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}
                        
                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }


    addRecord = async event => {
        let data = [...this.props.data];
        
        if (data.length>0){
            let lastRecord = data[data.length-1];
            var options = {  year: 'numeric', month: 'long', day: 'numeric' };
            var dt = new Date(new Date(lastRecord.review_date).setFullYear(new Date(lastRecord.review_date).getFullYear() + 1));
            
            data.push({
                lease_id: this.props.filter.leaseid,
                review_date: dt.toLocaleDateString('en-AU',options),
                lease_term : lastRecord.lease_term,
                review_type_code: lastRecord.review_type_code,
                review_type: lastRecord.review_type,
                percentage: lastRecord.percentage,
                price_incl_gst: false,
                created_by: this.props.user,
                last_edited_by: this.props.user,
                new_record: true

            });
        }
        else{
            //Update the following with the minimum details to create a record (all not nulls populated)
            //Requires updating per dataset
            data.push({
                lease_id: this.props.filter.leaseid,
                review_date: new Date(),
                price_incl_gst: false,
                created_by: this.props.user,
                last_edited_by: this.props.user,
                new_record: true

            });
        }
        this.props.updateTableState(data, this.state.dataSet);
    }

    renderTable(data) {
        const columns = [

            {
                id: 'lease_review_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'lease_review_id' ,
                Cell: e => <LinkContainer to={`../leasereview/${e.value}`}><a> {e.value} </a></LinkContainer>,
                maxWidth: 100

            }, {
                id: 'review_date',
                Header: 'Review Date',
                accessor: d => {
                    if (d.start_date) {
                        return Moment(d.start_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                },
                maxWidth: 100,
                Cell: this.renderEditable
            }, {
                id: 'lease_term',
                Header: 'Lease Term',
                accessor: 'lease_term',
                maxWidth: 250,
                Cell: this.renderEditable

            }
            , {
                id: 'review_type_code',
                Header: 'Review Type',
                accessor: 'review_type_code',
                maxWidth: 250,
                Cell: this.renderEditable

            }, {
                id: 'percentage',
                Header: 'Percentage',
                accessor: 'percentage',
                maxWidth: 150,
                Cell: this.renderEditable

            
            }, {
                id: 'revised_price_per_sqm',
                Header: 'Revised Price per sqm',
                accessor: 'revised_price_per_sqm',
                maxWidth: 150,
                Cell: this.renderEditable


            }, {
                id: 'revised_price_per_annum',
                Header: 'Revised Price per annum',
                accessor: 'revised_price_per_annum',
                maxWidth: 150,
                Cell: this.renderEditable


            }, {
                id: 'price_incl_gst',
                Header: 'Inc GST',
                accessor: 'price_incl_gst',
                maxWidth: 150,
                Cell: this.renderEditable


            },
            
            {
                Header: '',
                accessor: 'lease_review_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row, e)}>Delete</Button>,
                maxWidth: 100
            }
        ]

        if (!data || !this.props.reviewTypeOptions) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }



    }

    
    renderComponent() {
        return (
            <div className="leaseReviews">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.state.showWarning && 
                                    <Alert variant="danger">{this.state.errorMessage}</Alert>
                                    }
                <Row >
                    <Col className="text-right" >
                       {/*   <Button variant="secondary" size="sm" onClick={this.props.refreshDataSet}  >Refresh</Button>  */}
                        <Button variant="secondary" size="sm" onClick={this.addRecord}  >Add</Button>
                            
                                
                                
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading && this.props.reviewTypeOptions.length >1 && this.renderTable(this.props.data)}
                        </Col>
                    </Row>
 

            </div>
        );
    }
  render() {
    return (

        <div className="LeaseReviewList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
        </div>
    );
  }
}
